<template>
  <div class="main__column">
    <div class="main__block__header">
      <div class="item__row item__ac item__90 main__mb__m">
      </div>
      <div class="item__row main__sorts" v-if="showSort">
        <div class="item__column main__mr__m main__sort item__mt">
          <p class="">Сортировка</p>
          <v-col class="d-flex pa-0" cols="12" sm="11">
            <v-select
              @change="getCategory"
              v-model="sort"
              :items="sorts"
              item-text="value"
              item-value="id"
              label="Сортировка"
              outlined
              required
              dense
              hide-details
              color="white"
            ></v-select>
          </v-col>
        </div>

        <div class="item__column main__mr__m main__sort item__mt">
          <p class="">Цена</p>
          <div class="item__row">
            <div class="main__mr__s">
              <v-text-field
                color="white"
                type="number"
                v-model="priceFrom"
                label="От"
                outlined
                @input="getCategory"
                dense
                hide-details
              ></v-text-field>
            </div>
            <v-text-field
              color="grey lighten-5"
              type="number"
              v-model="priceTo"
              label="До"
              outlined
              @input="getCategory"
              dense
              hide-details
            ></v-text-field>
          </div>
        </div>
      </div>
    </div>

    <div class="item__row item__ac item__pointer" @click="$router.push('/')">
      <v-icon size="32px" style="align-self: flex-start"> mdi-keyboard-backspace</v-icon>
      <p>Назад</p>
    </div>

    <transition name="fade">
      <div
          v-if="showElement"
          class="basket__notify--alert">
        <p class="basket__notify--title">Себетке салынды</p>
        <p class="basket__notify--count">Себетке өтіп санын көрсетіңіз</p>

        <div class="basket__notify--btn" @click="showBasket"><p>Тапсырыс бөліміне өту</p></div>

        <i class="mdi mdi-close" @click="showElement = false"></i>
      </div>
    </transition>
    <transition name="slide-in-down">
      <div class="main__block__products" v-if="!showLoaderProducts">
        <div
          class="main__block__product"
          v-for="(product, index) in all_products"
          :key="index"
        >
          <div class="product__images item__abs">
            <img
              v-if="product.images.length != 0"
              :src="$ROOT_BACK + product.images[0].image_path"
              class="product__slider__img"
              alt=""
            />
            <div class="item__column product__round" v-else>
              <i class="mdi mdi-package-variant main__empty"></i>
            </div>
          </div>

          <div class="main__product__bottom item__column item__ac">
            <p class="product__name"></p>

            <p class="product__name">{{ product.name }}</p>
            <p class="product__description" v-if="product.description!='null'" v-html="product.description"></p>
            <p class="product__size" v-if="product.size">Размеры: {{ product.size }}</p>
            <div class="product__prices">
              <div
                class="item__column"
                v-if="product.price_sale && product.price_sale != 0"
              >
                  <div class="item__row item__ac">
                 <p class="product__price" v-if="product.count_type == 2">
                    {{ "/ " }}кг
                  </p>
                  <p class="product__price" v-if="product.count_type == 3">
                    {{ "/ " }}литр
                  </p>
                  <p class="product__price__has__sale">
                    <s>{{ formatNumber(product.price) + " ₸ " }}</s>
                  </p>
                 
                </div>
                <div class="item__row item__ac">
                  <p class="product__price">
                    {{ formatNumber(product.price_sale) + " ₸ " }}
                  </p>
                  <p class="product__price" v-if="product.count_type == 2">
                    {{ "/ " }}кг
                  </p>
                  <p class="product__price" v-if="product.count_type == 3">
                    {{ "/ " }}литр
                  </p>
                </div>
              
              </div>
              <div class="item__row item__ac" v-else>
                <p class="product__price">{{ formatNumber(product.price) + " ₸ " }}</p>
                <p class="product__price" v-if="product.count_type == 2">{{ "/ " }}кг</p>
                <p class="product__price" v-if="product.count_type == 3">
                  {{ "/ " }}литр
                </p>
              </div>
            </div>
            <div class="product__sale" v-if="product.percent && product.price_sale != 0">
              <p>-{{ product.percent }} &nbsp;%</p>
            </div>
            <div class="product__order" @click="sendBasket(index)">

              <i class="mdi mdi-basket"></i>
            </div>
          </div>
        </div>
      </div>

      <div class="main__block__products" v-else>
        <div class="item__column item__ac main__block__product item__js__c">
          <v-skeleton-loader type="card-avatar, actions"></v-skeleton-loader>
        </div>
        <div class="item__column item__ac main__block__product item__js__c">
          <v-skeleton-loader type="card-avatar, actions"></v-skeleton-loader>
        </div>

        <div class="item__column item__ac main__block__product item__js__c">
          <v-skeleton-loader type="card-avatar, actions"></v-skeleton-loader>
        </div>

        <div class="item__column item__ac main__block__product item__js__c">
          <v-skeleton-loader type="card-avatar, actions"></v-skeleton-loader>
        </div>

        <div class="item__column item__ac main__block__product item__js__c">
          <v-skeleton-loader type="card-avatar, actions"></v-skeleton-loader>
        </div>
      </div>
    </transition>
    <v-pagination
      v-model="page"
      :length="length"
      circle
      color="#fd1d1d"
      :total-visible="7"
      @input="paginate()"
      class="item__family"
    ></v-pagination>
  </div>
</template>

<script>
export default {
  props: ["openBasket","currentPage","currentCategoryId"],
  data() {
    return {
      phone_number: "",
      hasProduct: false,
      length: 1,
      page: this.currentPage,
      showSort: false,
      priceTo: "",
      priceFrom: "",
      sort: null,
      sorts: [
        {
          id: 1,
          value: "Популярные",
        },
        {
          id: 2,
          value: "Новинки",
        },
        {
          id: 3,
          value: "Сначала дешевые",
        },
        {
          id: 4,
          value: "Сначала дорогие",
        },
      ],
      all_products: [],
      items: [
        {
          value: 1,
          lbel: "Сначала дешевые",
        },
        {
          value: 2,
          label: "Сначала дорогие",
        },
      ],
      filter: {
        filter: true,
      },
      nameProduct: "",
      showLoader: false,
      showLoaderCategory: true,
      showLoaderProducts: true,
      orderCreated: false,
      basket: [],
      bread: [],
      subcategory: false,
      nested: [],
      amount: 0,
      orders: [],
      count: 0,
      all_count: 0,
      isActive: true,
      open_description: false,
      categories: [],
      products: [],
      description: [],
      basket_amount: 0,
      before_category: [],
      bread_categories: [],

      next_page_url: "",
      total_page: 0,
      resized: false,
      showElement: false
    };
  },
  mounted() {
    setInterval(this.hideElement,3500)
    window.scrollTo(0, 600);
    if (window.screen.width < 900) {
      this.resized = true;
    }
    if (localStorage.getItem("goods")) {
      this.basket = JSON.parse(localStorage.getItem("goods"));
      this.basketAmount();
    }
    if (localStorage.getItem("basket_amount")) {
      this.basket_amount = parseInt(localStorage.getItem("basket_amount"));
    }
    this.getProductByCategory();
  },
  watch: {
    $route() {
      if(this.$route.params.id) {
        this.page = 1
        this.all_products = [];
        this.getProductByCategory();
      }
    },
    openBasket() {
      console.log("changed")
    }
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    showBasket() {
      this.$router.push('/basket')
    },
    hideElement() {
      this.showElement = false
    },
    async getCategories() {
      const config = {
        headers: { Authorization: `Bearer ${this.token}` },
      };
      await this.$http.get("/get/categories", config).then((res) => {
        this.categories = res.data;
        this.showLoaderCategory = false;
        this.bottom_categories = this.categories[0];
      });
    },
    sendBasket(index) {
      // let myAudio = document.querySelector('#audio')
      // myAudio.play()
      this.showElement = true
      if (this.basket.length != 0) {
        if (!this.checkHasEl(index)) {
          this.all_products[index].order_price = this.all_products[index].price_sale
            ? this.all_products[index].price_sale
            : this.all_products[index].price;
          this.basket.push(this.all_products[index]);
        }
      } else {
        this.all_products[index].order_price = this.all_products[index].price_sale
          ? this.all_products[index].price_sale
          : this.all_products[index].price;
        this.basket.push(this.all_products[index]);
      }
      localStorage.setItem("goods", JSON.stringify(this.basket));
      this.basketAmount();
      this.$parent.getCount();
    },
    getChars(str) {
      let arr = [];
      for (var i = 0; i < str.length; i++) {
        arr.push(str.charAt(i));
      }
      return arr;
    },
    handleScroll() {
      // let bottomOfWindow = document.documentElement.scrollTop + window.innerHeight === document.documentElement.offsetHeight;
      // if (bottomOfWindow) {
      //   setTimeout(function () { this.showMore() }.bind(this), 100);
      // }
    },
    formatNumber(number) {
      if (!number) {
        return 0;
      }
      let parts = number.toString().split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
      return parts.join(".");
    },
    searchProduct() {
      this.all_products = [];
      this.$http
        .get("/search/product?name=" + this.nameProduct.toLowerCase())
        .then((res) => {
          this.all_products = [];
          this.total_page = res.data.total;
          this.next_page_url = res.data.next_page_url;

          this.products = res.data.data;

          this.hasProduct = this.products.length != 0 ? true : false;

          for (let index = 0; index < this.products.length; index++) {
            this.all_products.push(this.products[index]);
          }
          this.showLoaderProducts = false;
        });
    },
    paginate() {
      window.scroll(0,600);
      this.showLoader = true;
      this.getProductByCategory();
    },

    deleteEl(id, index) {
      this.basket_amount = this.basket_amount - this.basket[index].order_price;
      this.basket = this.basket.filter((item) => item.id !== id);

      localStorage.setItem("goods", JSON.stringify(this.basket));
      localStorage.setItem("basket_amount", this.basket_amount);

      // this.$parent.getCount(-1);
    },

    checkHasEl(index) {
      var found = false;
      for (var i = 0; i < this.basket.length; i++) {
        if (this.basket[i].id == this.all_products[index].id) {
          found = true;
          break;
        }
      }
      return found;
    },

    basketAmount() {
      this.basket_amount = 0;
      for (let index = 0; index < this.basket.length; index++) {
        this.basket_amount = this.basket_amount + this.basket[index].order_price;
      }

      let p = this.basket_amount;
      this.basket_amount = 0;
      this.basket_amount = p;
      localStorage.setItem("basket_amount", this.basket_amount);
    },
    corousel_img(index) {
      this.description.corousel_index = index;

      let permanent = this.description;
      this.description = [];
      this.description = permanent;
    },
    scrollImage(index, img_index) {
      this.products[index].scroll_index = img_index;

      let permanent = this.products;
      this.products = [];
      this.products = permanent;
    },
    getProducts() {
      this.$http.get("/guest/get/products").then((res) => {
        this.total_page = res.data.total;
        this.length = res.data.last_page;
        this.next_page_url = res.data.next_page_url;

        this.products = res.data.data;
        this.hasProduct = this.products.length !== 0 ? true : false;

        for (let index = 0; index < this.products.length; index++) {
          this.all_products.push(this.products[index]);
        }
        this.showLoaderProducts = false;
      });
    },
    openProduct(id, category_id, index) {
      this.open_description = true;
      this.description = this.products[index];
      this.$router.push("/category/" + category_id + "/product/" + id);
    },
    async getProductByCategory() {
      this.all_products = [];
      this.showLoaderProducts = true;
      if(!this.$route.params.id) {
         this.$route.params.id = localStorage.getItem('category_id');
      }
      await this.$http.post("guest/get/products/by/category?category_id="+this.$route.params.id+'&page='+this.page, {}).then((res) => {
        this.next_page_url = res.data.next_page_url;
        this.total_page = res.data.total;
        this.all_products = res.data.data;
        this.length = res.data.last_page;
        let permanent = this.products;
        this.products = [];
        this.products = permanent;
        this.showLoaderProducts = false;
        for (let index = 0; index < this.products.length; index++) {
          this.all_products.push(this.products[index]);
        }
      });
    },
  },
};
</script>

<style lang="less">
@mobile: 900px;
@planshet: 1200px;

.modal {
  display: flex;
  justify-content: center;
}
.main__color__filter {
  color: var(--main-kenes-blue) !important;
}
.plp-svg-icon {
  font-size: 14px;
  width: 35px;
  margin-left: 10px;
  cursor: pointer;
}

.main__sort {
  width: 300px;
  @media (max-width: 900px) {
    align-items: flex-start;
    justify-content: center;
    width: 80%;
    margin-right: 0;
  }

  p {
    color: white;
    font-weight: bold;
    margin-bottom: 8px !important;
  }
  v-select__selections {
    font-family: "MediumMedium";
    color: white;
    border: 1px solid white;
    @media (max-width: 900px) {
      width: 100%;
    }
  }
}

.main__sorts {
  @media (max-width: 900px) {
    flex-direction: column;
    width: 100%;
    align-items: center;
  }
}

.ab_center {
  display: flex;
  justify-content: center;
  align-items: center;
}
.product__row__c {
  align-items: center;
}
.product__row__jb {
  justify-content: space-between;
}
.product__column {
  display: flex;
  flex-direction: column;
}
.produc__column__c {
  align-items: center;
}

.main__mr__xs {
  margin-right: 5px;
}
.main__mr__s {
  margin-right: 15px;
}
.main__mr__m {
  margin-right: 20px;
}
.main__mb__xs {
  margin-bottom: 10px !important;
}
.main__mb__s {
  margin-bottom: 15px !important;
}
.main__mb__m {
  margin-bottom: 20px !important;
}
.main__mb__l {
  margin-bottom: 25px;
}
.main__mb__xl {
  margin-bottom: 30px;
}


.basket__notify--alert {
  padding: 20px;
  position: fixed;
  top: 20;
  background: #3fca5f;
  min-width: 500px;
  border-radius: 10px;
  z-index: 5000;
  align-self: center;
  margin: auto 0;
  @media (max-width: 900px) {
    min-width: unset;
    width: 93%;
    padding: 10px 20px;
  }

}
.basket__notify--title {
  font-size: 20px;
  font-weight: bold;
  color: white;
  margin-bottom: 20px;
  @media (max-width: 900px) {
    font-size: 16px;
  }
}
.basket__notify--count {
  color: white;
  margin-bottom: 20px;
  @media (max-width: 900px) {
    font-size: 12px;
  }
}
.basket__notify--btn {
  cursor: pointer;
  background: white;
  color: black;
  padding: 10px;
  border-radius: 5px;
  width: 200px;
  margin-top: 20px;
  font-weight: bold;
  p {
    @media (max-width: 900px) {
      font-size: 12px;
    }
  }
}
.basket__notify--btn:hover {
  opacity: 0.8;
}
.mdi-close {
  cursor: pointer;
  font-size: 25px;
  color: white;
  position: absolute;
  right: 10px;
  top: 10px;
}
</style>
